/**
 * Created by jiayanfeng on 2018/3/9.
 */

export const Portal_Page_Content = "Portal_Page/Content";
export const Portal_Page_Reset_Content = "Portal_Page/Reset_Content";
// export const Portal_Page_Header = "Portal_Page/Header";
// export const Portal_Page_Redirect_Item = "Portal_Page/Redirect_Item";
// export const Portal_Page_Advertisement = "Portal_Page/Advertisement";
// export const Portal_Page_Rapid_Reg = "Portal_Page/Rapid_Reg";
